import apiConfig from "@apiConfig";
import { components } from "@apiSchema";
import http from "@core/fetch";
import { useData } from "@hooks/useData";

const REQUEST_TYPE: keyof typeof apiConfig = 'get common flavor categories';
type Response = components["schemas"]["ConsumerPreferencesCategory"][];

async function getCommonFlavorCategories(): Promise<Response> {
    try {
        return await http.get(REQUEST_TYPE) as Response;
    } catch (error) {
        console.error('Fetch error:', REQUEST_TYPE, error);
        return [];
    }
}

export function useCommonFlavorCategories() {
    return useData([], getCommonFlavorCategories);
}